
import React, { useEffect, useState, useRef } from 'react';
import { Button, Col, Input, Row, notification } from 'antd';
import 'antd/dist/antd.css';
import Axios from './../../config/axiosConfig/axios';
import { Api } from './../../config/apiList/api';
import './Login.css';
import loginIcon from './../../assets/images/loginIcon.png';
import { useNavigate } from 'react-router-dom';


function Login() {

    const [windowSize, setWindowSize] = useState(getWindowSize());
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [tokens, setTokens] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);
    function getWindowSize() {
        const { innerWidth, innerHeight } = window;
        return { innerWidth, innerHeight };
    }



    const sumbitLogin = () => {
        if (userName.length !== 0) {
            if (password.length !== 0) {


                var data = {
                    "userName": userName,
                    "password": password
                }

                Axios.post("", `${Api}login-panel`, data)
                    .then(async (data) => {
                        if (data.statusCode === 200 || data.statusCode === 201) {

                            await localStorage.setItem('token', data.data.token);

                            await navigate('/');


                            notification.open({
                                message: "موفقیت",
                                description: "شما با موفقیت وارد سامانه شدید !",
                                style: {
                                    background: "#43a047",
                                    color: "white",
                                    fontFamily: "IRANSansMobileFaNum",
                                    borderRadius: "5px",
                                }
                            })
                        } else {
                            notification.open({
                                message: data.data + "اخطار مشکلی پیش آمده",
                                description: data.message,
                                style: {
                                    background: "#F3585c",
                                    color: "white",
                                    fontFamily: "IRANSansMobileFaNum",
                                    borderRadius: "5px",
                                }
                            })
                        }
                    })
                    .catch((error) => {
                        notification.open({
                            message: error,
                            description:
                                'مشکلی در سرور پیش آمده است ، لطفا بعدا تلاش فرمایید',
                            style: {
                                background: "#F3585c",
                                color: "white",
                                fontFamily: "IRANSansMobileFaNum",
                                borderRadius: "5px",
                            }
                        })
                    })
            } else {
                notification.open({

                    message: "اخطار",
                    description: "پسورد نمی تواند خالی باشد",
                    style: {
                        background: "#F3585c",
                        color: "white",
                        fontFamily: "IRANSansMobileFaNum",
                        borderRadius: "5px",
                    }
                })
            }

        } else {
            notification.open({

                message: "اخطار",
                description: "نام کاربری نمی تواند خالی باشد",
                style: {
                    background: "#F3585c",
                    color: "white",
                    fontFamily: "IRANSansMobileFaNum",
                    borderRadius: "5px",
                }
            })
        }
    }
    
    if (localStorage.getItem('token') != null &&localStorage.getItem('token') !=="" && localStorage.getItem('token') !== undefined) {
        window.location.replace("/");

    }
    else {

    return (

        <Row style={{ background: '#546e7a', width: '100%', height: windowSize.innerHeight, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Col xxl={16} xl={16} lg={16} md={16} sm={22} xs={22} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div id='loginHolder' style={{ width: '70%', justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                    <img src={loginIcon} style={{ width: '80px', height: '80px' }} />
                    <p id='loginText'> ورود به پنل مدیریت املاک پارسیان</p>
                    <Input
                        onChange={(e) => { setUserName(e.target.value) }}
                        className='loginInput'
                        placeholder='userName' />
                    <Input
                        onChange={(e) => { setPassword(e.target.value) }}
                        className='loginInput'
                        placeholder='password'
                        type='password' />
                    <Button id='loginBtn' onClick={sumbitLogin}>ورود به پنل مدیریت</Button>
                </div>
            </Col>
        </Row>
    );
    }
}
export default Login;

